import styled from 'styled-components';
import { Button, Image, Box, Flex, Grid } from '../../atoms';
export const Container = styled(Grid).attrs(props => Object.assign({
  pt: 2,
  pb: 3,
  px: 3,
  backgroundColor: 'background.lighter',
  borderRadius: 'medium'
}, props))`
  grid-template-columns: minmax(auto, 64px) auto;
  grid-template-areas: ${({
  hasFigure
}) => hasFigure ? `'f c'
        'b b'` : `'c c'
        'b b'`};
`;
export const CardContent = styled(Flex).attrs(props => Object.assign({
  my: 3,
  mx: 2
}, props))`
  flex-direction: column;
  justify-content: space-around;
  grid-area: c;
`;
export const FigureContainer = styled(Box).attrs(props => Object.assign({
  my: 3,
  mx: 2,
  minWidth: '64px'
}, props))`
  grid-area: f;
`;
export const CardFigure = styled(Image)``;
export const CardTitle = styled(Box).attrs(props => Object.assign({
  forwardedAs: 'p',
  color: 'text.base',
  fontWeight: 'medium',
  fontSize: 2
}, props))``;
export const CardText = styled(Box).attrs(props => Object.assign({
  forwardedAs: 'p',
  color: 'text.base',
  fontWeight: 'regular',
  fontSize: 1,
  lineHeight: 'big'
}, props))``;
export const CardButton = styled(Button)`
  width: 100%;
  text-transform: uppercase;
  grid-area: b;
`;